<template>
  <div class="step-form-wrapper">
    <el-scrollbar
      ref="scrollbar_ref"
      :wrap-class="{ 'step-form-scrollbar-wrapper': steps.length !== 0 }"
      class="w-full h-full"
      wrap-style="overflow-x:hidden;"
    >
      <div
        v-for="(form_item, field_key) in formFields.config"
        :id="getFormRefName([parentKey, field_key, steps.length ? 'assign' : 'preview', 'wrap'], '__')"
        :key="getFormRefName([parentKey, field_key])"
        v-loading="form_item.loading"
      >
        <div v-if="form_item.title" class="card-header w-full flex items-center">
          <h3 slot="header" class="title m-0">{{ form_item.title }}</h3>
        </div>
        <app-form
          :ref="getFormRefName([parentKey, field_key])"
          default-label-width="170px"
          :data-ref="getFormRefName([parentKey, field_key])"
          :submit-request="(params) => onSubmit(params, getFormRefName([parentKey, field_key]))"
          :form-data="form_item.config"
          :is-show-button="false"
          :form-props="{ labelPosition: 'right' }"
        >
          <template #custom="{ form_item, form_key }">
            <component
              :is="getDynamicComponentName(field_key)"
              :form-key="form_key"
              :form-item="form_item"
              :form-fields="formFields"
              :init-ops="init_ops"
            />
          </template>
        </app-form>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { generateFieldName } from '@/views/fusion/investment/intelligence-create/tools';

export default {
  components: {
    'app-form': () => import('@/components/app-form'),
  },
  mixins: [data_sharing_mixin],
  props: {
    // 父模块名称
    parentKey: {
      type: String,
      required: true,
    },
    // 表单配置
    formFields: {
      type: Object,
      default() {
        return {};
      },
    },
    // 侧边栏导航数据
    steps: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      // 动态渲染表单映射
      dynamic_component_map: {
        campaign_config: {
          base_form: {
            default: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/base-form/index.vue'),
          },
          site_form: {
            [CHANNEL_INTERFACE_TYPE.GDT]: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/site-form/channel-interface/gdt/index.vue'),
          },
          delivery_form: {
            default: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/delivery-form/index.vue'),
          },
          schedule_form: {
            default: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/schedule-form/index.vue'),
          },
          budget_and_bid_form: {
            default: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/budget-and-bid-form/index.vue'),
            [CHANNEL_INTERFACE_TYPE.GDT]: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/budget-and-bid-form/channel-interface/gdt/index.vue'),
            [CHANNEL_INTERFACE_TYPE.BAIDU]: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/budget-and-bid-form/channel-interface/baidu/index.vue'),
          },
        },
        creative_config: {
          base_form: {
            default: () => import(`@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/base-form/index.vue`),
          },
          content_form: {
            [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => import(`@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/content-form/channel-interface/huawei/index.vue`),
            [CHANNEL_INTERFACE_TYPE.GDT]: () => import(`@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/content-form/channel-interface/gdt/index.vue`),
            [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => import(`@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/content-form/channel-interface/bilibili/index.vue`),
            [CHANNEL_INTERFACE_TYPE.JRTT]: () => import(`@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/content-form/channel-interface/jrtt/index.vue`),
            [CHANNEL_INTERFACE_TYPE.BAIDU]: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/content-form/channel-interface/baidu/index.vue'),
          },
          creative_components: {
            [CHANNEL_INTERFACE_TYPE.GDT]: () => import(`@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/creative-components/channel-interface/gdt/index.vue`),
            [CHANNEL_INTERFACE_TYPE.OPPO]: () => import(`@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/creative-components/channel-interface/oppo/index.vue`),
            [CHANNEL_INTERFACE_TYPE.JRTT]: () => import(`@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/creative-components/channel-interface/jrtt/index.vue`),
            [CHANNEL_INTERFACE_TYPE.BAIDU]: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/creative-components/channel-interface/baidu/index.vue'),
          },
        },
      },
      form_model: {},
    };
  },
  computed: {
    // 初始化数据
    init_ops() {
      const { getFormContext } = this.local_sharing_data;
      const form_context = getFormContext();
      const { init_ops } = form_context.config;
      return init_ops || {};
    },
  },
  methods: {
    /**
     * 获取动态表单名称
     * @param {string} field_key 表单键名
     */
    getDynamicComponentName(field_key) {
      const form = this.dynamic_component_map[this.parentKey][field_key];
      const { channel_interface } = this.init_ops;
      return form ? (form[channel_interface] || form['default']) : null;
    },
    /**
     * 获取表单ref键名
     * @param {string[]} args 键名数据
     * @param {string} separator 连接符
     */
    getFormRefName(args = [], separator = '.') {
      return generateFieldName(args, separator);
    },
    /**
     * 效验所有表单
     * @param is_validate 是否效验数据
     * @param is_filter_empty 是否过滤空值
     */
    async validateAllForm(is_validate = true, is_filter_empty = true) {
      let valid = false;
      this.form_model = {};
      const exclude_refs = ['scrollbar_ref', 'schedule_time_ref'];
      for (const field in this.$refs) {
        if (
          Object.hasOwnProperty.call(this.$refs, field) &&
          !exclude_refs.includes(field)
        ) {
          const refs = this.$refs[field];
          for (const ref of refs) {
            valid = await ref.confirm(is_validate, is_filter_empty);
            if (!valid && is_validate) {
              break;
            }
          }
          if (!valid && is_validate) {
            break;
          }
        }
      }
      return valid;
    },
    /**
     * 表单回调
     * @param {Object} params 表单数据
     * @param {string} field ref键名
     */
    onSubmit(params, field) {
      Object.assign(this.form_model, { [field]: params });
    },
    /**
     * 弹窗内容区块滚动
     * @param {*} key
     */
    onScroll(key) {
      const target = document.querySelector(`#${key}`);
      const scrollbar_ref = this.$refs['scrollbar_ref'].wrap;
      scrollbar_ref.scroll({ top: target.offsetTop, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.step-form-wrapper {
  height: 400px;
}
</style>

<style lang="scss">
.step-form-wrapper {
  .pt-0 {
    padding-top: 0;
  }
  .children-form-widget {
    padding-top: 9px !important;
  }
  .card-header {
    padding: 0 20px;
    min-height: 42px;
    border-bottom: 1px solid rgb(240, 240, 240);
    background: rgba(0, 0, 0, 0.02);
    transition: background 0.2s ease;
  }
  .form-widget {
    background: rgba(0, 0, 0, 0.02);
    transition: background 0.2s ease;
    padding: 20px;
  }
  .multi-form-section {
    margin-left: 120px !important;
    margin-right: 120px !important;
    border: 1px solid rgb(230, 235, 245);
    border-bottom: none;
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      cursor: pointer;
      border-radius: 4px;
      background-color: rgba(144, 147, 153, 0.1);
      transition: 0.3s background-color;
      &:hover {
        background-color: rgba(144, 147, 153, 0.3);
      }
    }
    .el-form-item__label {
      width: 180px !important;
    }
    .el-form-item__label + .el-form-item__content {
      margin-left: 180px !important;
    }
  }
  .deep-nesting-form {
    .el-form-item__content {
      line-height: 0;
    }
  }
}
</style>
